/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AiControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public getAiAnswer({
        question,
        dataType,
        requestBody,
    }: {
        question: 'SUMMARY' | 'ADDRESS_INVOLVED' | 'VALUE_TRANSFERRED',
        dataType: 'USER_TRANSACTION' | 'STATE_CHECKPOINT_TRANSACTION' | 'BLOCK_METADATA_TRANSACTION' | 'BLOCK' | 'TRANSACTION' | 'BLOCK_EPILOGUE_TRANSACTION',
        requestBody: Record<string, any>,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/ai',
            query: {
                'question': question,
                'dataType': dataType,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
